/**
 * 版本检测工具 - 仅首次加载检测更新
 */
class UpdateChecker {
  constructor(options = {}) {
    // 配置项
    this.config = {
      versionUrl: options.versionUrl || "/work/version.json", // 版本文件地址
      onUpdateFound: options.onUpdateFound || null, // 更新发现回调
    };

    this.hasChecked = false; // 标记是否已完成首次检测
  }

  // 初始化 - 仅执行一次检测
  init() {
    // 只检测一次，避免重复执行
    if (!this.hasChecked) {
      this.checkUpdate();
      this.hasChecked = true;
    }

    // 可选：监听页面切回前台时检测（用户切回标签页时）
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && this.hasChecked) {
        this.checkUpdate();
      }
    });
  }

  // 获取服务器版本
  async getServerVersion() {
    try {
      // 添加时间戳避免缓存请求
      const response = await fetch(`${this.config.versionUrl}?t=${Date.now()}`);
      if (!response.ok) {
        throw new Error(`请求失败：${response.status}`);
      }
      const data = await response.json();
      return data.version;
    } catch (error) {
      console.error("获取版本信息失败：", error);
      return null;
    }
  }

  // 检测更新
  async checkUpdate() {
    const serverVersion = await this.getServerVersion(); // 修复之前的方法调用错误
    if (!serverVersion) return;

    // 从本地存储获取上次版本
    const localVersion = localStorage.getItem("app_version");

    // 首次加载，存储版本
    if (!localVersion) {
      localStorage.setItem("app_version", serverVersion);
      return;
    }

    // 版本不一致，说明有更新
    if (serverVersion !== localVersion) {
      console.log("检测到新版本，即将刷新页面...");

      // 执行自定义回调（比如显示更新提示）
      if (typeof this.config.onUpdateFound === "function") {
        this.config.onUpdateFound(serverVersion);
      } else {
        // 默认行为：清除缓存并刷新
        this.forceRefresh(serverVersion);
      }
    }
  }

  // 强制刷新页面（清除缓存）
  forceRefresh(newVersion) {
    // 更新本地版本
    localStorage.setItem("app_version", newVersion);
    // 强制刷新页面（true参数强制绕过缓存）
    window.location.reload(true);
  }
}

// 创建单例实例
const updateChecker = new UpdateChecker({
  // 自定义更新提示（推荐使用，提升用户体验）
  onUpdateFound: (newVersion) => {
    updateChecker.forceRefresh(newVersion);
  },
});

export default updateChecker;
